module.exports = __webpack_public_path__ + "static/img/背景1.3d51877.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/WisdomSite/背景1.png
// module id = +EsR
// module chunks = 12